import React, { useState, useRef } from 'react';
import { Send } from 'react-feather';
import { useChatbot } from './ChatbotContext';

/**
 * Area de input do chat com botao de enviar
 */
const ChatbotInput = () => {
  const { sendMessage, isTyping } = useChatbot();
  const [text, setText] = useState('');
  const inputRef = useRef(null);

  const handleSend = () => {
    if (!text.trim() || isTyping) return;
    sendMessage(text);
    setText('');
    // Focar de volta no input
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chatbot-input-area">
      <textarea
        ref={inputRef}
        className="chatbot-input"
        value={text}
        onChange={(e) => setText(e.target.value.slice(0, 1000))}
        onKeyDown={handleKeyDown}
        placeholder={isTyping ? 'Phada está digitando...' : 'Pergunte ou peça uma análise...'}
        disabled={isTyping}
        rows={1}
        maxLength={1000}
        aria-label="Mensagem para o copiloto"
      />
      <button
        type="button"
        className="chatbot-send-btn"
        onClick={handleSend}
        disabled={!text.trim() || isTyping}
        title="Enviar mensagem"
        aria-label="Enviar mensagem"
      >
        <Send size={18} />
      </button>
    </div>
  );
};

export default ChatbotInput;
